import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { getUnitFormatters } from 'pages/MaintenancePage/helpers/getUnitFormatters';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// Segments render as Wrappers, matching EventTypeSelector exactly — ag-ui Button
// ships its own fill/padding/width rules the segment styles had to out-specify, so
// the selected state now shares one implementation with the sibling selectors.
const UnitSelector: FunctionComponent<Props> = ({
    className = '',
    onSelect,
    partType,
    testId = TEST_ID,
    unitCount,
    unitSelection
}) => {
    const t = useTranslation();
    const unitFormatters = getUnitFormatters(t);
    const formatUnit = unitFormatters[partType] ?? t.LOG_SERVICE_UNIT_NUMBER;
    const unitNumbers = Array.from({ length: unitCount }, (_, index) => index + 1);
    const selectedUnitNumber = unitSelection.kind === 'unit' ? unitSelection.unitNumber : undefined;
    // No segment is active until the user chooses — 'unchosen' renders nothing selected.
    const allSelectedClass = unitSelection.kind === 'allUnits' ? styles.isSelected : '';

    return (
        <VerticalContainer className={`${styles.unitSelector} ${className}`} testId={testId}>
            <Wrapper className={styles.label}>{t.LOG_SERVICE_UNIT}</Wrapper>

            <HorizontalContainer className={styles.options}>
                <Wrapper
                    className={`${styles.segment} ${allSelectedClass}`}
                    onClick={() => onSelect({ unitSelection: { kind: 'allUnits' } })}
                    testId={`${testId}-all`}>
                    {t.UNIT_ALL}
                </Wrapper>

                {unitNumbers.map(unitNumber => {
                    const selectedClass =
                        unitNumber === selectedUnitNumber ? styles.isSelected : '';

                    return (
                        <Wrapper
                            onClick={() =>
                                onSelect({ unitSelection: { kind: 'unit', unitNumber } })
                            }
                            className={`${styles.segment} ${selectedClass}`}
                            key={unitNumber}
                            testId={`${testId}-${unitNumber}`}>
                            {formatUnit({ number: unitNumber })}
                        </Wrapper>
                    );
                })}
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default UnitSelector;
